import React from "react"
import {
  Main,
  LeftSide,
  RightSide,
  Wrapper,
  ButtonMain,
  ButtonWrapper,
  GoldenButton,
  ArrowBox,
} from "./style"
import image1 from "../../../../assets/images/rent-description-image1.jpg"
import image2 from "../../../../assets/images/rent-description-image2.jpg"
import arrow from "../../../../assets/images/arrow.png"
import { Link } from "../../../Link"

interface Props {
  field1: string[];
  field2: string[];
  button1: string;
  button2: string;
}

const DescriptionComponent: React.FC<Props> = ({ field1, field2, button1, button2 }) => {
  return (
    <>
      <ArrowBox>
        <img src={arrow} alt="arrow" />
      </ArrowBox>

      <Main>
        <Wrapper>
          <LeftSide imageFirst={false}>
            {field1 && field1.map(p => <p key={p}>{p}</p>)}
          </LeftSide>

          <RightSide imageFirst={false} image={image1} />
        </Wrapper>
      </Main>

      <Main>
        <Wrapper>
          <LeftSide imageFirst={true}>
            {field2 && field2.map(p => <p key={p}>{p}</p>)}
          </LeftSide>

          <RightSide imageFirst={true} image={image2} />
        </Wrapper>
      </Main>

      <ButtonMain>
        <ButtonWrapper>
          <Link to="/kontakt/#form">
            <GoldenButton>{button1}</GoldenButton>
          </Link>
          <Link to="/kontakt/#agents">
            <GoldenButton>{button2}</GoldenButton>
          </Link>
        </ButtonWrapper>
      </ButtonMain>
    </>
  )
}

export default DescriptionComponent
